module.exports = __webpack_public_path__ + "static/media/Timelapse.397b03ed.mp4";